import type { SyncOperation } from '../../sync/core/syncTypes';
import {
  IngestRejectedError,
  submitCommand,
  type SubmitCommandResult,
} from '../../sync/core/submitCommand';

/**
 * Wrapper de cash_session: el `rejected` del ingest (validación de negocio,
 * ej. "Ya hay una caja abierta en esta sucursal") vuelve como resultado
 * estructurado — los callers clasifican con mapCashCommandError y pueden
 * adoptar el turno remoto (reconcileCashOpenAfterRemoteConflict).
 * Sin esto el throw crudo bypasea captureOpsFailure y llega a Sentry sin tags
 * (VUELTO-NEGOCIO-3Q).
 */
export async function submitCashSessionCommand(
  operation: SyncOperation,
  payload: Record<string, unknown>,
): Promise<SubmitCommandResult> {
  try {
    return await submitCommand({ entity: 'cash_session', operation, payload });
  } catch (error) {
    if (error instanceof IngestRejectedError) {
      return {
        applied: false,
        enqueued: false,
        ingestOutcome: 'rejected',
        ingestError: error.ingestError,
      };
    }
    throw error;
  }
}
